module.exports = __webpack_public_path__ + "img/Natalie Tsang.f7995fe0.jpg";